import { apiUrl } from '@/lib/apiBase'

interface RouteGpxEvent {
  id: string
  route: {
    id?: string | null
    gpx_url?: string | null
    gpxUrl?: string | null
  } | null
}

export function routeGpxUrlFor(event: RouteGpxEvent): string | null {
  if (!event.route) return null

  if (event.route.id) {
    return apiUrl(
      `public/events/${encodeURIComponent(event.id)}/routes/${encodeURIComponent(event.route.id)}/gpx`,
    )
  }

  return event.route.gpxUrl ?? event.route.gpx_url ?? null
}

export function routeGpxCacheMode(url: string): RequestCache {
  return url.includes('/rails/active_storage/') ? 'no-cache' : 'default'
}

/**
 * The course's world pack on the app's own API base, like the GPX: the payload's `world_url` is
 * absolute on whatever host served it, which another origin (a dev proxy) can't fetch. Only its
 * `v`, the build, is kept, so the URL stays immutable. Null until the server has built the world.
 */
export function routeWorldUrlFor(event: {
  id: string
  route: { id?: string | null; world_url?: string | null } | null
}): string | null {
  const route = event.route
  if (!route?.id || !route.world_url) return null
  const version = new URL(route.world_url, 'http://placeholder').searchParams.get('v')
  const path = apiUrl(`public/events/${encodeURIComponent(event.id)}/routes/${encodeURIComponent(route.id)}/world`)
  return version ? `${path}?v=${encodeURIComponent(version)}` : path
}
